export const deleteProjects = ({ BeURL, id, showAlert, setProjects,  handleTopClear }) => {
    fetch(`${BeURL}/candidate-projects-delete/${id}`, {
        method: "DELETE",
        credentials: 'include'
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                showAlert(data.message)
                setProjects(data.projects)
                handleTopClear()
            }
            else {
                alert(data.message)
            }
        })
        .catch(err => {
            console.log("Error to Delete candidate projects", err)
        })
}
